import * as Yup from "yup";

// Mirrors Constant.CLOSURE_REJECT_REASON_MIN_LENGTH (10) server-side.
export const CLOSURE_REJECT_REASON_MIN_LENGTH = 10;

export const closureRejectSchema = Yup.object().shape({
  reason: Yup.string()
    .trim()
    .min(
      CLOSURE_REJECT_REASON_MIN_LENGTH,
      `Reason must be at least ${CLOSURE_REJECT_REASON_MIN_LENGTH} characters`,
    )
    .required("A reason is required"),
});

export const supportReopenSchema = Yup.object().shape({
  reason: Yup.string()
    .trim()
    .min(10, "Business justification must be at least 10 characters")
    .required("A business justification is required"),
});